import React from 'react'
import { has_franchise_reach, is_shop_admin, is_superuser } from '../Functionalities/Config'

export default function EditTopComponent({ page, swipe, Edit, DeleteButton, AddButtonName, AddButtonPath, CancelButton, BackButtonPath, EditButton, ExtraButton, ExtraButtonName }) {
  // void 0
  return (
    page == "Restaurant"
      ?
      <div className="card-header">
        <div className="d-sm-flex mb-lg-4 mb-2">
          <div className="mt-4" className="text-left">
            <a href onClick={() => { window.history.back() }} className="btn btn-primary mb-1 mr-1"> Back </a>
          </div>
        </div>
        <div className="d-sm-flex mb-lg-4 mb-2">
          <div className="mt-4" className="text-right">
            {ExtraButton && <a href="" className="btn btn-primary mb-1 mr-1" onClick={ExtraButton} >  {ExtraButtonName}</a>}


            {(is_superuser || has_franchise_reach) && !swipe && DeleteButton && <a href="" className="btn btn-primary mb-1 mr-1" onClick={DeleteButton} > Delete </a>}
            {/* {is_superuser && !swipe && (AddButtonPath && <a href={AddButtonPath} className="btn btn-primary mb-1 mr-1"> {AddButtonName} </a>)} */}
            {/* <div className="shopping-cart mt-3"> */}
            {!swipe &&
              (Edit ?
                <a onClick={CancelButton} className="btn btn-danger mb-1 mr-1"
                  href="javascript:void(0)" >Cancel</a>
                :
                (is_superuser || has_franchise_reach || is_shop_admin) && EditButton && <a onClick={EditButton} className="btn btn-primary mb-1 mr-1" href="javascript:void(0)" ><i className="fa fa-edit mr-2" />Edit</a>)
            }


          </div>
        </div>
      </div>
      :
      <div className="card-header">
        <div className="d-sm-flex mb-lg-4 mb-2">
          <div className="mt-4" className="text-left">
            <a href={BackButtonPath} onClick={() => { window.history.back(window.location.reload()) }}   className="btn btn-primary mb-1 mr-1"> Back </a>
          </div>
        </div>
        <div className="d-sm-flex mb-lg-4 mb-2">
          <div className="mt-4" className="text-right">
            {ExtraButton &&
              <a href="" className="btn btn-primary mb-1 mr-1" onClick={ExtraButton} >  {ExtraButtonName}</a>}
            {(is_superuser || has_franchise_reach || is_shop_admin) && DeleteButton && <a href="" className="btn btn-primary mb-1 mr-1" onClick={DeleteButton} > Delete </a>}
            {(is_superuser || has_franchise_reach || is_shop_admin) && (AddButtonPath && <a href={AddButtonPath} className="btn btn-primary mb-1 mr-1"> {AddButtonName} </a>)}
            {/* <div className="shopping-cart mt-3"> */}
            {Edit ?
              <a onClick={CancelButton} className="btn btn-danger mb-1 mr-1"
                href="javascript:void(0)" >Cancel</a>
              :
              (is_superuser || has_franchise_reach || is_shop_admin) && EditButton && <a onClick={EditButton} className="btn btn-primary mb-1 mr-1" href="javascript:void(0)" ><i className="fa fa-edit mr-2" />Edit</a>
            }
          </div>
        </div>
      </div>
  )
}

